import React from 'react';
import Faq from "react-faq-component";

const data = {
    title: <h3 className="faq-title">How it Works</h3>,
    rows: [
        {
            title: <h4 className="faq-question">How Do I Enrol?</h4>,
            content: <p className="faq-answer">To enrol for a program, go to the "Tracks" tab and pick a track. You can enrol for any track of your choice as long as you meet the requirements.</p>,
        },
        {
            title: <h4 className="faq-question">Do I Get a Certificate After Course Completion?</h4>,
            content: <p className="faq-answer">Yes, students who enrol for a track will at the completion of their program get certification for the course they enrolled for.</p>,
        },
        {
            title: <h4 className="faq-question">What are the Criteria For The Award of a Certificate</h4>,
            content: <p className="faq-answer">To be awarded a certificate, enrolled students must take the required quiz and complete the required tasks.</p>,
        },
        {
            title: <h4 className="faq-question">How Do I See My Assigned Tasks</h4>,
            content: <p className="faq-answer">There are tasks assigned for every track you enrol for. To see tasks assigned to your tracks, go to "enrolled" tab to see the courses you enrolled for and the required tasks.</p>,
        },
        {
            title: <h4 className="faq-question">How Do I Submit My Completed Tasks</h4>,
            content: <p className="faq-answer">To submit your completed task, go to the "Enrolled" tab and click the "Submit Task" button for the track whose task you want to submit.</p>,
        },
    ],
};

const styles = {
    titleTextColor: "#2D3748",
    rowTitleColor: "#2D3748",
    rowContentColor: "#4A5568",
    arrowColor: "#3182CE",
    rowTitleTextSize: "1.1rem",
    rowContentTextSize: "1rem",
    rowContentPaddingTop: "1rem",
    rowContentPaddingBottom: "1.5rem",
    rowContentPaddingLeft: "1rem",
    rowContentPaddingRight: "1rem",
    rowTitlePaddingTop: "1rem",
    rowTitlePaddingBottom: "1rem",
    rowTitlePaddingLeft: "1rem",
    rowTitlePaddingRight: "1rem",
    bgColor: "#FFFFFF",
    rowContentBgColor: "#F7FAFC",
    rowTitleBgColor: "#FFFFFF",
    transitionDuration: "0.3s",
    borderColor: "#E2E8F0"
};

const config = {
    animate: true,
    tabFocus: true,
    expandIcon: "+",
    collapseIcon: "−"
};

const FAQComponent = () => {
    return (
        <div className="faq-container">
            <Faq
                data={data}
                styles={styles}
                config={config}
            />
            
            <style jsx>{`
                .faq-container {
                    width: 100%;
                    max-width: 800px;
                    margin: 0 auto;
                    padding: 2rem 1rem;
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                }
                
                :global(.faq-title) {
                    text-align: center;
                    color: #2D3748;
                    font-size: 2rem;
                    font-weight: 700;
                    margin-bottom: 2rem;
                    padding: 1rem;
                }
                
                :global(.faq-question) {
                    font-weight: 600;
                    color: #2D3748;
                    margin: 0;
                    font-size: 1.1rem;
                    line-height: 1.5;
                }
                
                :global(.faq-answer) {
                    color: #4A5568;
                    margin: 0;
                    line-height: 1.6;
                    font-size: 1rem;
                }
                
                @media (max-width: 768px) {
                    .faq-container {
                        padding: 1rem 0.5rem;
                    }
                    
                    :global(.faq-title) {
                        font-size: 1.5rem;
                        margin-bottom: 1.5rem;
                    }
                    
                    :global(.faq-question) {
                        font-size: 1rem;
                    }
                }
            `}</style>
        </div>
    );
}

export default FAQComponent;